var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-slider"
  }, [_c('div', {
    staticClass: "product-slider__zoom-box"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-slider__blackout"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-slider__zoom-hint p p_fz11 p_tac p_grey"
  }, [_vm._v("\n    Наведите на фотографию для увеличения\n  ")]), _vm._v(" "), _c('div', {
    ref: "selector",
    staticClass: "product-slider__photos",
    style: ("cursor: " + (_vm.cursor)),
    on: {
      "mouseenter": _vm.mouseenterHandler,
      "mouseup": _vm.mouseupHandler,
      "mousedown": function ($event) {
        $event.preventDefault();
        return _vm.mousedownHandler.apply(null, arguments);
      },
      "mouseleave": _vm.mouseleaveHandler,
      "mousemove": function ($event) {
        $event.preventDefault();
        return _vm.mousemoveHandler.apply(null, arguments);
      },
      "touchstart": _vm.touchstartHandler,
      "touchend": _vm.touchendHandler,
      "touchmove": _vm.touchmoveHandler
    }
  }, [_vm.photo.length ? _c('div', {
    staticClass: "product-slider__width",
    style: _vm.styleHandler
  }, _vm._l(_vm.photo, function (url, index) {
    return _c('div', {
      key: index,
      staticClass: "product-slider__photo"
    }, [_c('div', {
      ref: "zoomWrapper",
      refInFor: true,
      staticClass: "product-slider__photo-zoom-wrapper",
      style: {
        styleZoomWrapper: _vm.zoomActive
      }
    }, [_c('img', {
      staticClass: "product-slider__photo-img",
      attrs: {
        "src": url,
        "alt": _vm.alt
      }
    })])]);
  }), 0) : _c('div', {
    staticClass: "product-slider__photo product-slider__photo_empty"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/empty.svg")
    }
  })])]), _vm._v(" "), _vm.photo.length > 1 ? _c('div', {
    staticClass: "product-slider__thumbs"
  }, [_c('div', {
    ref: "selectorPreviewWrapper",
    staticClass: "product-slider__thumbs-wrapper"
  }, [_vm._l(_vm.photo, function (url, index) {
    return _c('div', {
      key: index,
      staticClass: "product-slider__thumb",
      class: [index === _vm.currentSlide ? 'product-slider__thumb_active' : ''],
      on: {
        "click": function ($event) {
          return _vm.clickIconHandler(index);
        }
      }
    }, [_c('LazyImg', {
      staticClass: "product-slider__thumb-img",
      attrs: {
        "img": url,
        "alt": "Фото товара"
      }
    })], 1);
  }), _vm._v(" "), _c('div', {
    staticClass: "product-slider__mobile"
  }, [_c('DotSlider', {
    staticClass: "slider__dots",
    attrs: {
      "current": _vm.currentSlide,
      "count": _vm.photo.length
    }
  })], 1)], 2)]) : _vm._e(), _vm._v(" "), _c('Photoswipe', {
    attrs: {
      "is-open": _vm.isOpen,
      "items": _vm.items,
      "options": _vm.options
    },
    on: {
      "close": _vm.hidePhotoSwipe
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }